import React from "react"
export default function About (){
    return(
       <section id="about">
       <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
         <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
           <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
             Hi, I'm Asma.
             <br className="hidden lg:inline-block" />I love to build amazing
             web apps.
           </h1>
           <p className="mb-8 leading-relaxed">
           Energetic software engineer with 14 years’ experience in developing robust code for high-volume businesses. Experienced in
core PHP, Laravel and Node.js. Proficient in HTML, CSS and ReactJS and Jquery. Excellent skills of Database designing and
optimization. Have worked on versatile products and projects including shopping carts, property management, educational
websites, order management applications, API integrations and blogs. An enthusiastic team player and deep creative thinker.
           </p>
           <div className="flex justify-center">
             <a
                to='#'
                onClick={() => window.location = 'mailto:ainasma786@gmail.com'}
               className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
               Work With Me
             </a>
             <a
               href="#projects"
               className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
               See My Past Work
             </a>
           </div>
         </div>
         <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
           <img
             className="object-cover object-center rounded"
             alt="hero"
             src="./coding.svg"
           />
         </div>
       </div>
     </section>
 
    )
}


// WEBPACK FOOTER //
// ./src/components/About.js